"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObvioFooter = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const components_1 = require("./components");
function Logo() {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "23", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M0 0h5.197l8.786 22.722H8.816L0 0ZM19.596 9.322 23.303 0h-5.613l-3.709 9.322h5.614Z" }) })));
}
function ObvioFooter({ className }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(components_1.Wrap, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: "https://obvio.pl" }, { children: (0, jsx_runtime_1.jsxs)(components_1.CenteredStack, { children: [(0, jsx_runtime_1.jsx)(Logo, {}), (0, jsx_runtime_1.jsx)(components_1.Title, { children: t('obvio.footer.cmsSolutions') })] }) })) })));
}
exports.ObvioFooter = ObvioFooter;
